module.exports = __webpack_public_path__ + "static/img/customize_cn.5073a3b7.jpg";